module.exports = __webpack_public_path__ + "static/media/TN-Women-Dress-2.0_OptionAll.d157b926.svg";